import React from "react";

import { Page } from "../../layouts/Page";
import {
  ReportingPageHeader,
  ReportingOverview
} from "../../molecules/Reporting";
import { Callout, Intent, Spinner } from "@blueprintjs/core";

import useOverviewReport from "./useOverviewReport";
import useVideoReport from "./useVideoReport";
import useProductReport from "./useProductReport";
import { ReportingVideo, ReportingProduct } from "../../molecules/Reporting";

function OverviewReport() {
  const {
    loading,
    overviewReport,
    filters,
    filterOptions,
    setFilters
  } = useOverviewReport();

  return (
    <Page title="Reporting" flex>
      <ReportingPageHeader
        filters={filters}
        filterOptions={filterOptions}
        setFilters={setFilters}
      />

      {/* <Callout intent={Intent.WARNING} style={{ marginBottom: 50 }}>
        Video Squirrel is currently experiencing longer than average load times
        for our reporting metrics, and we are working to resolve the issue.
        Thank you for your patience and we apologize for the inconvenience.
      </Callout> */}

      {loading && <Spinner />}
      {!loading && (
        <ReportingOverview
          overviewReport={overviewReport}
          dateRange={filters.date}
        />
      )}
    </Page>
  );
}

function VideoReport({ video }) {
  const {
    loading,
    videoReport,
    filters,
    filterOptions,
    setFilters
  } = useVideoReport({ video });

  return (
    <Page title="Reporting" flex>
      <ReportingPageHeader
        video={videoReport}
        filters={filters}
        filterOptions={filterOptions}
        setFilters={setFilters}
      />
      {loading && <Spinner />}
      {!loading && (
        <ReportingVideo videoReport={videoReport} dateRange={filters.date} />
      )}
    </Page>
  );
}

function ProductReport({ product }) {
  const {
    loading,
    productReport,
    filters,
    filterOptions,
    setFilters
  } = useProductReport({ product });

  return (
    <Page title="Reporting" flex>
      <ReportingPageHeader
        product={productReport}
        filters={filters}
        filterOptions={filterOptions}
        setFilters={setFilters}
      />
      {loading && <Spinner />}
      {!loading && (
        <ReportingProduct
          productReport={productReport}
          dateRange={filters.date}
        />
      )}
    </Page>
  );
}

function Reporting({ match }) {
  if (match.params.videoId) return <VideoReport video={match.params.videoId} />;
  if (match.params.productId)
    return <ProductReport product={match.params.productId} />;

  return <OverviewReport />;
}

export default Reporting;
